import { createAction, handleActions } from "redux-actions";

import constants from "../../assets/constants";

const actionScope = "ONBOARDING_SESSION_";

export const onboardingSessionRequestFailed = createAction(actionScope + "REQUEST_FAIL");

export const setInviteKeyRequest = createAction(actionScope + "SET_INVITE_ID_REQUEST");
export const setInviteKeySuccess = createAction(actionScope + "SET_INVITE_ID_SUCCESS");

export const loadOnboardingODMRequest = createAction(actionScope + "LOAD_ONBOARDING_ODM_REQUEST");
export const loadOnboardingODMSuccess = createAction(actionScope + "LOAD_ONBOARDING_ODM_SUCCESS");

export const setOnboardingODMRequest = createAction(actionScope + "SET_ONBOARDING_ODM_REQUEST");
export const setOnboardingODMSuccess = createAction(actionScope + "SET_ONBOARDING_ODM_SUCCESS");

export const setOnboardingStatusRequest = createAction(
  actionScope + "SET_ONBOARDING_STATUS_REQUEST"
);
export const setOnboardingStatusSuccess = createAction(
  actionScope + "SET_ONBOARDING_STATUS_SUCCESS"
);

export const onboardUserRequest = createAction(actionScope + "ONBOARD_USER_REQUEST");
export const onboardUserSuccess = createAction(actionScope + "ONBOARD_USER_SUCCESS");

export const unsubscribeUserRequest = createAction(actionScope + "UNSUBSCRIBE_USER_REQUEST");
export const unsubscribeUserSuccess = createAction(actionScope + "UNSUBSCRIBE_USER_SUCCESS");

export const setUnsubscribeStatusRequest = createAction(
  actionScope + "SET_UNSUBSCRIBE_STATUS_REQUEST"
);
export const setUnsubscribeStatusSuccess = createAction(
  actionScope + "SET_UNSUBSCRIBE_STATUS_SUCCESS"
);

export const setOrganizationODMRequest = createAction(actionScope + "SET_ORGANIZATION_ODM_REQUEST");
export const setOrganizationODMSuccess = createAction(actionScope + "SET_ORGANIZATION_ODM_SUCCESS");

export const setAssesssmentODMRequest = createAction(actionScope + "SET_ASSESSMENT_ODM_REQUEST");
export const setAssesssmentODMSuccess = createAction(actionScope + "SET_ASSESSMENT_ODM_SUCCESS");

export const setOnboardingProctorODMRequest = createAction(
  actionScope + "SET_ONBOARDING_PROCTOR_ODM_REQUEST"
);
export const setOnboardingProctorODMSuccess = createAction(
  actionScope + "SET_ONBOARDING_PROCTOR_ODM_SUCCESS"
);

export const setOnboardingSubjectODMRequest = createAction(
  actionScope + "SET_ONBOARDING_Subject_ODM_REQUEST"
);
export const setOnboardingSubjectODMSuccess = createAction(
  actionScope + "SET_ONBOARDING_Subject_ODM_SUCCESS"
);

export const setOnboardingAssessmentTypeRequest = createAction(
  actionScope + "SET_ONBOARDING_ASSESSMENT_TYPE_REQUEST"
);
export const setOnboardingAssessmentTypeSuccess = createAction(
  actionScope + "SET_ONBOARDING_ASSESSMENT_TYPE_SUCCESS"
);

export const setOnboardingHTMLRequest = createAction(actionScope + "SET_ONBOARDING_HTML_REQUEST");
export const setOnboardingHTMLSuccess = createAction(actionScope + "SET_ONBOARDING_HTML_SUCCESS");
// selectors
export const onboardingODMSeletor = state => state.onboardingSession.onboardingODM;
export const inviteKeySelector = state => state.onboardingSession.inviteKey;

// initial state
const initialState = {
  onboardingODM: null, // this is the User we are onboarding
  organizationODM: null, //this is the org associated with this invite. Loading for Config params.
  assessmentODM: null, //this is the assessment to be submitted during onboarding
  onboardingProctorODM: null, //this is the proxy to be submitted during onboarding
  onboardingSubjectODM: null, //this is the subject of the Onboarding

  onboardingStatus: null,
  inviteKey: null, //this is the id passed to the page as query params. It should get set by the portal.
  onboardingSuccess: false,

  unsubscibeStatus: "Please Wait...",
  unsubscribeSuccess: false,

  onboardingAssessmentType: constants.assessmentIDs.omniHealthHistory, //default
  onboardingHTML: null,
};

// reducers
export default handleActions(
  {
    [onboardingSessionRequestFailed]: state => state,

    [loadOnboardingODMRequest]: state => state,
    [loadOnboardingODMSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [setOnboardingODMRequest]: state => state,
    [setOnboardingODMSuccess]: (state, { payload }) => ({
      ...state,
      onboardingODM: payload,
    }),

    [setOnboardingStatusRequest]: state => state,
    [setOnboardingStatusSuccess]: (state, { payload }) => ({
      ...state,
      onboardingStatus: payload,
    }),

    [setOrganizationODMRequest]: state => state,
    [setOrganizationODMSuccess]: (state, { payload }) => ({
      ...state,
      organizationODM: payload,
    }),

    [setAssesssmentODMRequest]: state => state,
    [setAssesssmentODMSuccess]: (state, { payload }) => ({
      ...state,
      assessmentODM: payload,
    }),

    [setOnboardingProctorODMRequest]: state => state,
    [setOnboardingProctorODMSuccess]: (state, { payload }) => ({
      ...state,
      onboardingProctorODM: payload,
    }),

    [setOnboardingSubjectODMRequest]: state => state,
    [setOnboardingSubjectODMSuccess]: (state, { payload }) => ({
      ...state,
      onboardingSubjectODM: payload,
    }),

    [setOnboardingAssessmentTypeRequest]: state => state,
    [setOnboardingAssessmentTypeSuccess]: (state, { payload }) => ({
      ...state,
      onboardingAssessmentType: payload,
    }),

    [setOnboardingHTMLRequest]: state => state,
    [setOnboardingHTMLSuccess]: (state, { payload }) => ({
      ...state,
      onboardingHTML: payload,
    }),

    [setInviteKeyRequest]: state => state,
    [setInviteKeySuccess]: (state, { payload }) => ({
      ...state,
      inviteKey: payload,
      onboardingSuccess: false,
    }),

    [onboardUserRequest]: state => state,
    [onboardUserSuccess]: (state, { payload }) => ({
      ...state,
      onboardingSuccess: true,
      //what do we do here? force redirect?
      //we should be leaving this portal if successful.
    }),

    [unsubscribeUserRequest]: state => state,
    [unsubscribeUserSuccess]: (state, { payload }) => ({
      ...state,
      unsubscribeSuccess: true,
      //what do we do here? force redirect?
      //we should be leaving this portal if successful.
    }),

    [setUnsubscribeStatusRequest]: state => state,
    [setUnsubscribeStatusSuccess]: (state, { payload }) => ({
      ...state,
      unsubscibeStatus: payload,
    }),
  },
  initialState
);
